module.exports = __webpack_public_path__ + "images/FUSA_icons/026-payment-method-2.98083c4093f1a2328937bd60a137d65a.svg";